module.exports = __webpack_public_path__ + "static/favicon-1b9682e3e79b683cc0ff79acd3db3d77.ico";